import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiKey } from "../../../config/config";
import MessageCard from "../../../components/AdminCards/MessageCard";
import { toast } from "react-toastify";

function EditTopBannerForm() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({
    text: "",
    status: "",
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    axios
      .post(`${apiKey}/api/rms/admin/topbanner`, formData, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        navigate(-1);
      })
      .catch((err) => {
        setError(err.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/topbanner`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setFormData(res.data.data);
      })
      .catch((err) => {
        setError(err.response.data.message);
      })
      .finally(() => {
        setPageLoading(false);
      });
  }, [user?.token]);

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="loading..." />
      </div>
    );
  }
  
  if (error) {
    return <MessageCard error={error} />;
  }

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-d-bg-text text-2xl">Edit Top banner</h1>
          </div>
        </div>
        <div className="w-full">
          <form onSubmit={handleSubmit} className="w-full">
            <label htmlFor="" className="w-full md:w-1/2">
              <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                Text
              </span>
              <div className="mb-2 pt-0">
                <input
                  type="text"
                  name="text"
                  placeholder="Text"
                  value={formData.text}
                  onChange={handleChange}
                  className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                />
              </div>
            </label>
            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="https://i.gifer.com/ZKZx.gif"
                      alt=""
                    />
                  </span>
                )}
                Submit
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default EditTopBannerForm;
